export default __webpack_public_path__ + "static/nandini1-16326c03f355ce406fab0c8d5b5f93f1.jpg";